import React, { useState, useEffect, useRef, useCallback } from 'react';
import ReactFlow, {
  ReactFlowProvider,
  addEdge,
  useNodesState,
  useEdgesState,
  Controls,
} from 'reactflow';
import 'reactflow/dist/style.css';
import '../css/dataTablePopUp.css';

import '../css/draggableColumn.css';

const GroupByPopupComponent = ({ onClose, onRemoveTable, nodeName, selectedNodeId, onValueSubmit,
  nodes, setNodes, edges, setEdges, droppedNodes, setDroppedNodes, data,
  selectedCurrentTable, selectedCurrentDatabase,
  columnsData, selectedRightListValue, selectedLeftListValue,
  selectedPreviousTable, aliasColumn, aliasFunctionNames,
  windowFunctionWithCondition, catalogsData,
  databasesData, tablesData, connectionType
}) => {
  console.log("columnsData::1", columnsData)
  
  let columnsDataValues;
  let localcolumnsData;
  if (columnsData == undefined|| columnsData.length==0){
    columnsData = []
  }

  if (columnsData && columnsData.length > 1) {
    console.log("columnsData::2", columnsData)
    columnsDataValues = [].concat(...columnsData);
    //if (aliasColumn.length > 0) {
      //columnsDataValues = columnsDataValues.concat(aliasColumn);
    //}
  } else {
    columnsDataValues = columnsData;
    //if (aliasColumn.length > 0) {
      //columnsDataValues = columnsDataValues.concat(aliasColumn);
    //}
  }
  console.log("columnsData::3", JSON.stringify(columnsDataValues), aliasColumn);
  // Flatten the columnsDataValues array
  columnsDataValues = columnsDataValues.flat();

  if (connectionType == "kafka") {  
    /*
    //json_extract_scalar(kafka_test.tpch.customer._message_rowNumber)
    const name = columnsDataValues[0].split("_message_")
    columnsDataValues[0] = "json_extract_scalar(" + name[0] + "_message" + ", '$." + name[1] + "')"
    console.log(JSON.stringify(columnsDataValues) + "columnDat::group::3",);
  */
    console.log("columnData::group::1", JSON.stringify(columnsDataValues))
    for (let i = 0; i < columnsDataValues.length; i++) {
        const name = columnsDataValues[i].split("_message_")
        columnsDataValues[i] = "json_extract_scalar(" + name[0] + "_message" + ", '$." + name[1] + "')"
        console.log("columnData::group::2", JSON.stringify(columnsDataValues))
    }
  }
  console.log(JSON.stringify(columnsDataValues) + "columnsDataValues::group::2");

  const [name, setName] = useState(nodeName);
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [leftList, setLeftList] = useState(selectedLeftListValue &&
    selectedLeftListValue.length > 0 ? selectedLeftListValue : columnsDataValues || []);

  const [selectedCatalogs, setSelectedCatalogs] = useState(catalogsData && catalogsData.length > 0 ? catalogsData : []);
  const [selectedSchemas, setSelectedSchemas] = useState(databasesData && databasesData.length > 0 ? databasesData : []);
  const [selectedTables, setSelectedTables] = useState(tablesData && tablesData.length > 0 ? tablesData : []);

  const [selectedDatabase, setSelectedDatabase] = useState(
    selectedCurrentDatabase && selectedCurrentDatabase ? selectedCurrentDatabase : data.databases[0]);
  const [selectedTable, setSelectedTable] = useState(
    selectedCurrentTable && selectedCurrentTable ? selectedCurrentTable :
      selectedDatabase[0]);

  const [rightList, setRightList] = useState(selectedRightListValue && selectedRightListValue.length > 0 ?
    selectedRightListValue : []);


  const handleRemoveTable = () => {
    // Call the onRemoveTable callback function
    var newNodes = []
    var newEdges = []
    var newDroppedNodes = []
    //console.log("onRemoveTable::1", nodes[0]["id"], selectedNodeId)
    if (onRemoveTable) {
      newNodes = nodes.filter((node) => node["id"] != selectedNodeId);
      newEdges = edges.filter((edge) => !edge["id"].includes(`-${selectedNodeId}`));
      //edataTable_1-
      for (let i = 0; i < droppedNodes.length; i++) {
        if (droppedNodes[i] === selectedNodeId) {
          droppedNodes.splice(i, 1);
          console.log("Remaining elements: " + droppedNodes);
        }
      }
      //newDroppedNodes = droppedNodes.filter(!selectedNodeId)
      console.log("onRemoveTable::2", newNodes, selectedNodeId, edges, newEdges, newDroppedNodes)
      onRemoveTable();  
    }
    // Close the popup
    setNodes(newNodes)
    setEdges(newEdges)
    setDroppedNodes(droppedNodes)
    //onClose(nodes)
  };

  const reactFlowWrapper = useRef(null);
  const [reactFlowInstance, setReactFlowInstance] = useState(null);
  const onDrop = useCallback(
    (event, list) => {
      event.preventDefault();

      const reactFlowBounds = reactFlowWrapper.current.getBoundingClientRect();
      const typeData = event.dataTransfer.getData('application/reactflow');
      const type = JSON.parse(typeData);

      if (!type) {
        return;
      }

      const position = reactFlowInstance.project({
        x: event.clientX - reactFlowBounds.left,
        y: event.clientY - reactFlowBounds.top,
      });


      if (list === 'left' && !leftList.includes(type)) {
        setRightList((columns) => columns.filter((column) => column !== type));
        setLeftList((columns) => [...columns, type]);
      }

      if (list === 'right' && !rightList.includes(type)) {
        setLeftList((columns) => columns.filter((column) => column !== type));
        setRightList((columns) => [...columns, type]);

      }
    },
    [reactFlowInstance, leftList, rightList]
  );


  const handleLinkClick = () => {
    // Perform any actions when the link is clicked
    // ...
  };

  const onDragStart = (event, column) => {

    event.dataTransfer.setData('application/reactflow', JSON.stringify(column));
    event.dataTransfer.effectAllowed = 'move';
  };
  const onDragOver = useCallback((event) => {
    event.preventDefault();
    event.dataTransfer.dropEffect = 'move';
  }, []);


  const handleDeleteColumn = (columnId) => {
    setRightList((columns) => columns.filter((column) => column !== columnId));
    setLeftList((columns) => {
      const existingColumn = rightList.find((column) => column === columnId);
      if (!existingColumn) {
        return [...columns];
      }
      return [...columns, existingColumn];
    });
  };

  const handleAddAll = () => {
    setRightList((prevRightList) => [...prevRightList, ...leftList]);
    setLeftList([]);
  };
  const handleRemoveAll = () => {
    setLeftList((prevLeftList) => [...prevLeftList, ...rightList]);
    setRightList([]);
  };

  useEffect(() => {
    setName(nodeName);
    if (selectedPreviousTable && selectedCurrentTable
      && selectedCurrentTable !== selectedPreviousTable) {
      //setLeftList(leftList);
      setLeftList(columnsData);
      setRightList([]);
    } else {


      if (selectedPreviousTable == undefined && selectedCurrentTable) {
        setLeftList(leftList);
        setRightList([]);
      } else if (selectedCurrentTable !== undefined && selectedPreviousTable !== undefined &&
        selectedCurrentTable === selectedPreviousTable) {

        const combinedLength = selectedLeftListValue.length + selectedRightListValue.length;

        if (combinedLength !== columnsDataValues.length) {
          // The combined length of leftListValue and rightListValue is different from selectedColumnsCombined
          setLeftList(columnsDataValues);
          setRightList([]);
        } else {
          // Check if all items in rightListValue are present in selectedColumnsCombined
          const isRightListValid = selectedRightListValue.every(item => columnsDataValues.includes(item));

          if (isRightListValid) {
            setLeftList(selectedLeftListValue);
            setRightList(selectedRightListValue);
          } else {
            setLeftList(columnsDataValues);
            setRightList([]);
          }
        }
      } else {
        setLeftList(columnsDataValues);
        setRightList([]);
      }
    }

  }, [nodeName]
  );

  // Function to update the dynamic value
  const handleNameChange = (event) => {

    setName(event.target.value);

  };

  const handleSubmit = (event) => {
    event.preventDefault();
    console.log(JSON.stringify(aliasFunctionNames) + "aliasFunctionNames");
    console.log(JSON.stringify(aliasColumn) + "aliasColumn");
    console.log(JSON.stringify(windowFunctionWithCondition) + "windowFunctionWithCondition");
    // const selectedColumns = rightList.map((column) => column);
    const selectedAliasFunctionColumns = rightList.map((column) => {
      if (windowFunctionWithCondition && windowFunctionWithCondition.length > 0) {
        // Check if the column is present in windowFunctionWithCondition
        // const match = windowFunctionWithCondition.find((item) => item.endsWith(` AS ${column}`));
        const match = windowFunctionWithCondition.flat().find((item) => item.endsWith(` AS ${column}`));
        if (match) {
          // If it's in windowFunctionWithCondition, return the first index of that match
          return match.split(" AS ")[0];
        } else {

          if (connectionType !== 'SQLite') {
            //  return `${selectedCatalogs[i]}.${selectedSchemas[i]}.${selectedTables[i]}.${column}`;
            //    return `${selectedCatalogs[i]}.${selectedSchemas[i]}.${selectedTables[i]}.${column}`;
            return `${column}`;

          } else {

            const parts = column.split('.');
            if (parts.length === 3) {
              // Assuming the format is catalog.schema.column
              return `${parts[2]}`; // Only use the column part
            } else {
              return column; // Keep it as is if the format is not as expected
            }
            // Use values from the current array
            //  return `${selectedTables[i]}.${column}`;

          }



        }
      }
      else {

        if (connectionType !== 'SQLite') {
          //   return `${selectedCatalogs[i]}.${selectedSchemas[i]}.${selectedTables[i]}.${column}`;
          return `${column}`;

        } else {
          const parts = column.split('.');
          if (parts.length === 3) {
            // Assuming the format is catalog.schema.column
            return `${parts[2]}`; // Only use the column part
          } else {
            return column; // Keep it as is if the format is not as expected
          }

        }
      }

    });

    const selectedRightListColumns = rightList.map((column) => {
      if (windowFunctionWithCondition && windowFunctionWithCondition.length > 0) {
        // Check if the column is present in windowFunctionWithCondition
        const match = windowFunctionWithCondition.flat().find((item) => item.endsWith(` AS ${column}`));


        if (match) {
          // If it's in windowFunctionWithCondition, return the first index of that match
          return match.split(" AS ")[1];
        } else {

          if (connectionType !== 'SQLite') {
            return `${column}`;

          } else {


            const parts = column.split('.');
            if (parts.length === 3) {
              // Assuming the format is catalog.schema.column
              return `${parts[2]}`; // Only use the column part
            } else {
              return column; // Keep it as is if the format is not as expected
            }

            // Use values from the current array
            //  return `${selectedTables[i]}.${column}`;

          }
        }
      }

      else {

        if (connectionType !== 'SQLite') {
          //  return `${selectedCatalogs[i]}.${selectedSchemas[i]}.${selectedTables[i]}.${column}`;
          return `${column}`;

        } else {

          const parts = column.split('.');
          if (parts.length === 3) {
            // Assuming the format is catalog.schema.column
            return `${parts[2]}`; // Only use the column part
          } else {
            return column; // Keep it as is if the format is not as expected
          }

          // Use values from the current array
          //   return `${selectedTables[i]}.${column}`;

        }
      }

    });
    console.log(leftList + "selectedColumns::group::2");
    onValueSubmit(selectedNodeId, name, selectedAliasFunctionColumns, selectedRightListColumns, leftList, selectedCurrentTable);
  };
  
   return (
    <div className="overlay">
      <div className="popup-datatable">
        <div className="popup-header">
          <h4 className="modal-title">Tool Options</h4>
          <button className="close-button" onClick={onClose}>
            <span>&times;</span>
          </button>
        </div>
        <div className="datatable-content">
          <div className="modal-body">
            <div className="form-group">
              <label htmlFor="textbox">Name </label>
              <input type="text" value={name} onChange={handleNameChange}
                className="form-control" id="textbox" />
            </div>
            <h3>Select which columns to include</h3>
            <p className="helpText">Drag columns into the list on the right and reorder as required. Click the 'x' button to remove selected columns.
            </p>

            <div className="list-container">
              <div className="leftlist-container" onDragOver={onDragOver} onDrop={(event) => onDrop(event, 'left')} >
                <ul>
                  {leftList.map((column) => {
                    if (typeof column === 'string') {
                      const parts = column.split('.');
                      if (parts.length > 0) {
                        let columnName = parts.pop();
                        if (connectionType == "kafka") {
                          columnName = "_message_" + columnName.replace("')","")
                        }
                        return (
                          <li
                            key={column}
                            className="blockItem ui-draggable"
                            draggable
                            onDragStart={(event) => onDragStart(event, column)}
                          >
                            {columnName}

                          </li>
                        );
                      } else {
                        return (
                          <li
                            key={column}
                            className="blockItem ui-draggable"
                            draggable
                            onDragStart={(event) => onDragStart(event, column)}
                          >
                            {column}

                          </li>
                        );
                      }
                    

                    } else {
                      // This is a column without catalog and schema information
                      return (
                        <li
                          key={column}
                          className="blockItem ui-draggable"
                          draggable
                          onDragStart={(event) => onDragStart(event, column)}
                        >

                          {column}
                        </li>
                      );
                    }
                  })}

                </ul>
              </div>

              <ReactFlowProvider>
                <div className="" ref={reactFlowWrapper}>
                  <ReactFlow
                    onInit={setReactFlowInstance}
                    onDrop={onDrop}
                    onDragOver={onDragOver}
                    fitView
                  >
                    <Controls />
                  </ReactFlow>
                </div>
              </ReactFlowProvider>
              <div className="rightlist-container" onDragOver={onDragOver} onDrop={(event) => onDrop(event, 'right')}>

                <ul>
                  {rightList.map((column) => {
                    if (typeof column === 'string') {
                      const parts = column.split('.');
                      if (parts.length > 1) {
                        // This is a column with catalog and schema information
                        let columnName = parts.pop();
                        if (connectionType == "kafka") {
                          columnName = "_message_" + columnName.replace("')", "")
                        }
                        return (
                          <li key={column} className="blockItem ui-draggable" draggable onDragStart={(event) => onDragStart(event, column)}>
                            {columnName}
                            <button className="crossmark-button" onClick={() => handleDeleteColumn(column)}>×</button>
                          </li>
                        );
                      } else {
                        // This is a column without catalog and schema information
                        return (
                          <li key={column} className="blockItem ui-draggable" draggable onDragStart={(event) => onDragStart(event, column)}>
                            {column}
                            <button className="crossmark-button" onClick={() => handleDeleteColumn(column)}>×</button>
                          </li>
                        );
                      }
                    } else {
                      return (
                        <li
                          key={column}
                          className="blockItem ui-draggable"
                          draggable
                          onDragStart={(event) => onDragStart(event, column)}
                        >
                          {column}
                          <button className="crossmark-button" onClick={() => handleDeleteColumn(column)}>×</button>

                        </li>
                      );
                    }
                  })}
                </ul>
              </div>

            </div>
            <div className="add-remove">
              <button type="button" className="btn btn-add" onClick={handleAddAll}>
                Add All
              </button>


              <button type="button" className="btn btn-removeall" onClick={handleRemoveAll}>
                Remove All
              </button>
            </div>
          </div>
        </div>
        <div className="form-group toolHelpLink">
          <a href="https://example.com" target="_blank" onClick={handleLinkClick}>
            How does this tool work?
          </a>
        </div>
        <div className="modal-footer">
          <button className="btn btn-danger" onClick={handleRemoveTable}>
            Delete Tool
          </button>
          <button type='button' className='btn btn-primary ok' onClick={handleSubmit}>OK</button>

        </div>
      </div>
    </div>
  );
};

export default GroupByPopupComponent;
